import api from './api';
import { openRemoteFile } from './nativeFileService';

const accessCache = new Map();

const getApiOrigin = () => {
  try {
    return new URL(api.defaults.baseURL, window.location.origin).origin;
  } catch (error) {
    return window.location.origin;
  }
};

const toAbsoluteAccessUrl = (url) => {
  if (/^https?:\/\//i.test(url || '')) return url;
  return `${getApiOrigin()}${String(url || '').startsWith('/') ? '' : '/'}${url || ''}`;
};

export const getStoredFileAccessUrl = async (path, disposition = 'inline') => {
  const normalizedPath = String(path || '').trim();
  if (!normalizedPath) throw new Error('File path is required.');
  if (/^blob:/i.test(normalizedPath)) return normalizedPath;

  const cacheKey = `${disposition}:${normalizedPath}`;
  const cached = accessCache.get(cacheKey);
  const nowSeconds = Math.floor(Date.now() / 1000);
  if (cached && cached.expires > nowSeconds + 15) return cached.url;

  const response = await api.post('/files/access-url', { path: normalizedPath, disposition });
  const accessUrl = toAbsoluteAccessUrl(response.data.url);
  accessCache.set(cacheKey, { url: accessUrl, expires: Number(response.data.expires) || nowSeconds });
  return accessUrl;
};

export const openStoredFile = async (path, disposition = 'inline') => {
  const accessUrl = await getStoredFileAccessUrl(path, disposition);
  const pathWithoutQuery = String(path || '').split(/[?#]/)[0];
  const encodedName = pathWithoutQuery.split('/').filter(Boolean).pop() || 'document';
  let fileName = encodedName;
  try {
    fileName = decodeURIComponent(encodedName);
  } catch (error) {
    // Conserva el nombre original si la ruta no usa una codificación URI válida.
  }

  return openRemoteFile(accessUrl, { fileName });
};

export const clearStoredFileAccessCache = () => accessCache.clear();
